import axios from 'axios'
import _get from 'lodash/get'

import { TAX_CONSULTATION_STATUS_BOOKED, USER_AGREEMENT_TYPE_TAX_CONSULTATION } from '../constants'
import { reportNylasBookingToSentry } from '../helpers/sentry'
import { getTaxConsultationById } from '../selectors/tax-consultations'
import { handleRequestError } from './request'

export const REQUEST_TAX_CONSULTATIONS = 'REQUEST_TAX_CONSULTATIONS'
export const RECEIVE_TAX_CONSULTATION = 'RECEIVE_TAX_CONSULTATION'
export const RECEIVE_TAX_CONSULTATIONS = 'RECEIVE_TAX_CONSULTATIONS'
export const REMOVE_TAX_CONSULTATION = 'REMOVE_TAX_CONSULTATION'
export const RECEIVE_TAX_CONSULTATION_AGREEMENT = 'RECEIVE_TAX_CONSULTATION_AGREEMENT'

const ASSIGN_TAX_CONSULTATION_ACCOUNTANT = 'ASSIGN_TAX_CONSULTATION_ACCOUNTANT'
const CREATE_TAX_CONSULTATION = 'CREATE_TAX_CONSULTATION'
const DELETE_TAX_CONSULTATION = 'DELETE_TAX_CONSULTATION'
const SAVE_TAX_CONSULTATION = 'SAVE_TAX_CONSULTATION'
const SAVE_TAX_CONSULTATION_STATUS = 'SAVE_TAX_CONSULTATION_STATUS'
const SAVE_NYLAS_BOOKING = 'SAVE_NYLAS_BOOKING'

export const createTaxConsultation = () => (dispatch, getState) => {
    dispatch({ type: CREATE_TAX_CONSULTATION })

    const { profile } = getState()
    const { id: userId } = profile

    return axios
        .post(`/taxconsultations`, { userId })
        .then((response) => {
            const responseData = _get(response, ['data'], {})
            dispatch(receiveTaxConsultation({ items: [responseData] }))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error))
            return Promise.reject(error)
        })
}

export const requestTaxConsultations = () => (dispatch) => {
    dispatch({ type: REQUEST_TAX_CONSULTATIONS })

    return axios
        .get(`/taxconsultations`)
        .then((response) => {
            const responseData = _get(response, ['data'], {})
            dispatch(receiveTaxConsultations({ items: responseData, fetchSuccessful: true }))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error))
        })
}

export const requestTaxConsultation =
    ({ taxConsultationId }) =>
    (dispatch) =>
        axios
            .get(`/taxconsultations/${taxConsultationId}`)
            .then((response) => {
                const responseData = _get(response, ['data'], {})
                dispatch(receiveTaxConsultations({ items: [responseData] }))
                return responseData
            })
            .catch((error) => {
                dispatch(handleRequestError(error))
            })

export const saveTaxConsultation = (data) => (dispatch, getState) => {
    dispatch({ type: SAVE_TAX_CONSULTATION })

    const taxConsultation = getTaxConsultationById(getState(), { taxConsultationId: data.id })

    return axios
        .put(`/taxconsultations/${data.id}`, { ...taxConsultation, ...data })
        .then((response) => {
            const responseData = _get(response, ['data'], {})
            dispatch(receiveTaxConsultation({ items: [responseData] }))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error))
            return Promise.reject(error)
        })
}

export const deleteTaxConsultation =
    ({ taxConsultationId }) =>
    (dispatch) => {
        dispatch({ type: DELETE_TAX_CONSULTATION })

        return axios
            .delete(`/taxconsultations/${taxConsultationId}`)
            .then((response) => {
                const responseData = _get(response, ['data'], {})
                dispatch(removeTaxConsultation({ taxConsultationId }))
                return responseData
            })
            .catch((error) => {
                dispatch(handleRequestError(error))
                return Promise.reject(error)
            })
    }

export const assignTaxConsultation =
    ({ taxConsultationId }) =>
    (dispatch) => {
        dispatch({ type: ASSIGN_TAX_CONSULTATION_ACCOUNTANT })

        return axios
            .post(`/taxconsultations/${taxConsultationId}/accountant`)
            .then((response) => {
                const responseData = _get(response, ['data'], {})
                dispatch(receiveTaxConsultation({ items: [responseData] }))
                return responseData
            })
            .catch((error) => {
                dispatch(handleRequestError(error))
                return Promise.reject(error)
            })
    }

export const saveTaxConsultationStatus = (taxConsultation) => (dispatch) => {
    dispatch({ type: SAVE_TAX_CONSULTATION_STATUS, payload: taxConsultation })

    const { id, status } = taxConsultation

    return axios
        .put(`/taxconsultations/${id}/status/${status}`)
        .then((response) => {
            const responseData = _get(response, ['data'], {})
            dispatch(receiveTaxConsultation({ items: [responseData] }))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error))
            return Promise.reject(error)
        })
}

export const createTaxConsultationAgreement =
    ({ taxConsultationId }) =>
    (dispatch, getState) => {
        const taxConsultation = getTaxConsultationById(getState(), { taxConsultationId })

        return axios
            .post(`/useragreements`, {
                accountantId: taxConsultation.accountantId,
                userId: taxConsultation.userId,
                taxConsultationId,
                userAgreementType: USER_AGREEMENT_TYPE_TAX_CONSULTATION,
            })
            .then((response) => {
                const responseData = _get(response, ['data'], {})
                dispatch(receiveTaxConsultationAgreement({ agreements: [responseData] }))
                dispatch(receiveTaxConsultation({ items: [{ ...taxConsultation, isMissingAgreement: false }] }))
                return responseData
            })
            .catch((error) => {
                dispatch(handleRequestError(error))
                return Promise.reject(error)
            })
    }

export const requestTaxConsultationAgreementDraft =
    ({ taxConsultationId }) =>
    (dispatch, getState) => {
        const taxConsultation = getTaxConsultationById(getState(), { taxConsultationId })

        return axios
            .post(`/useragreements/draft`, {
                accountantId: taxConsultation.accountantId,
                userId: taxConsultation.userId,
                taxConsultationId,
                userAgreementType: USER_AGREEMENT_TYPE_TAX_CONSULTATION,
            })
            .then((response) => {
                const responseData = _get(response, ['data'], {})
                dispatch(receiveTaxConsultationAgreement({ agreements: [responseData] }))
                return responseData
            })
            .catch((error) => {
                dispatch(handleRequestError(error))
            })
    }

export const requestTaxConsultationAgreement =
    ({ taxConsultationId }) =>
    (dispatch, getState) => {
        const taxConsultation = getTaxConsultationById(getState(), { taxConsultationId })

        return axios
            .get(`/taxconsultations/${taxConsultationId}/agreement`, {
                accountantId: taxConsultation.accountantId,
                userId: taxConsultation.userId,
                taxConsultationId,
                userAgreementType: USER_AGREEMENT_TYPE_TAX_CONSULTATION,
            })
            .then((response) => {
                const responseData = _get(response, ['data'], {})
                dispatch(receiveTaxConsultationAgreement({ agreements: [responseData] }))
                return responseData
            })
            .catch((error) => {
                if (_get(error, ['response', 'status']) === 404) {
                    return
                }

                dispatch(handleRequestError(error))
            })
    }

export const saveNylasBooking =
    ({ taxConsultationId, scheduledDateUtc, editToken, externalId }) =>
    (dispatch) => {
        dispatch({ type: SAVE_NYLAS_BOOKING })

        const updatedTaxConsultation = {
            id: taxConsultationId,
            scheduledDateUtc,
            status: TAX_CONSULTATION_STATUS_BOOKED,
            editToken,
            externalId,
        }

        return dispatch(saveTaxConsultation(updatedTaxConsultation))
            .then(() => dispatch(saveTaxConsultationStatus(updatedTaxConsultation)))
            .catch((exception) => {
                reportNylasBookingToSentry(exception, updatedTaxConsultation)
            })
    }

const receiveTaxConsultationAgreement = (data) => ({ type: RECEIVE_TAX_CONSULTATION_AGREEMENT, data })

const receiveTaxConsultation = (data) => ({ type: RECEIVE_TAX_CONSULTATION, data })

const removeTaxConsultation = ({ taxConsultationId }) => ({
    type: REMOVE_TAX_CONSULTATION,
    data: { taxConsultationId },
})

export const receiveTaxConsultations = (data) => ({ type: RECEIVE_TAX_CONSULTATIONS, data })
